import React, {useEffect,useState,useContext,useMemo,useCallback} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DataTable from "react-data-table-component";
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,Checkbox} from '@mui/material'; 
import {Edit as EditIcon,Visibility as VisibilityIcon, ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted, PeopleAltOutlined, AssignmentOutlined, ArrowBackIosNew } from '@mui/icons-material';

import $ from 'jquery';

function Register(){
    const { refreshKey } = useContext(RefreshContext);
  
const { aid ,aidtype} = useParams();

const [vendorCandidates, setStaff] = useState([]); // vendor
const [recruiterCandidates, setStaff2] = useState([]); // recruiter

const [fileUrl, setFileUrl] = useState(null);
const [fileType, setFileType] = useState(null);
const [total,setTotal]= useState(0);
const [results, setResults] = useState(null);
const [showResultsModal, setShowResultsModal] = useState(false);
const [mappedCases, setMappedCases] = useState([]);
const [mappedCasesLoading, setMappedCasesLoading] = useState(false);
const [mappedCasesError, setMappedCasesError] = useState("");
const [hasMappedLineupCases, setHasMappedLineupCases] = useState(false);
const [mappedCaseSelections, setMappedCaseSelections] = useState([]);
const [expandedMappedCaseId, setExpandedMappedCaseId] = useState(null);
const [mappedCaseDrafts, setMappedCaseDrafts] = useState({});
const [mappedCasesImporting, setMappedCasesImporting] = useState(false);

const [loadings, setTableLoading] = useState(true);
const [newloading,setNewLoading] = useState(false);

// External candidates (Karam Bot staging)
const [showExternalModal, setShowExternalModal]         = useState(false);
const [externalCandidates, setExternalCandidates]       = useState([]);
const [externalLoading, setExternalLoading]             = useState(false);
const [externalError, setExternalError]                 = useState('');
const [selectedExternal, setSelectedExternal]           = useState([]);
const [externalApproving, setExternalApproving]         = useState(false);
const [externalView, setExternalView]                   = useState('pending'); // 'pending' | 'unassigned'
const [extDetailId, setExtDetailId]                     = useState(null);
const [extDetailData, setExtDetailData]                 = useState(null);
const [extDetailLoading, setExtDetailLoading]           = useState(false);
const [selectedRows, setSelectedRows] = useState([]);
const [activeTab, setActiveTab] = useState("recruiter");
const [showRecruiter, setShowRecruiter] = useState(false);
const [showVendor, setShowVendor] = useState(false);
const [selectedRecruiter, selectRecruiter] = useState(null);
const [isSubmittingRequest, setIsSubmittingRequest] = useState(false);
const [filteredStaff, setFilteredStaff] = useState([]);
const [ivrdata,setIvrData] = useState("");
const [ivr,setIvr] = useState("");
const [candidates,setCandidates]= useState([]);
const [candidatesId,setCandidatesId]= useState([]);

const [recruiter, setRecruiter] = useState([]);
const [groupedData, setGroupedData] = useState([]);
const [experienceOptions,setExper] = useState([]);
const [qualificationOptions,setQual] = useState([]);

const navigate = useNavigate();
const [metaData, setMetaData] = useState({
  appname: '',
  edit: false,
  del: false,
  add: false,
  view: false,
  typess:'',
  icon:'',
  checkbox:0,
  defaultShow:10
});

const [filters, setFilters] = useState({
  qual: "",
  exp: ""
});

// Helper function to update state
const handleSelectChange = (name, selectedOption) => {
  setFilters(prev => ({
    ...prev,
    [name]: selectedOption ? selectedOption.value : ""
  }));
};

const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0); // Set this from your API response
  const limit = 50; 
  const maxPage = Math.ceil(totalRows / limit);
const [stats,setStats]= useState([]);
const [latestLineupId, setLatestLineupId] = useState("");

const normalizeMappedText = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

const findQualificationOption = (rawValue, options = []) => {
  const raw = normalizeMappedText(rawValue);
  if (!raw) return "";

  const direct = options.find((option) => {
    const optionValue = normalizeMappedText(option.value);
    const optionLabel = normalizeMappedText(option.label);
    return raw === optionValue || raw === optionLabel || raw.includes(optionValue) || raw.includes(optionLabel);
  });
  if (direct) return direct.value;

  if (/(b tech|btech|be |b e |bachelor of engineering|bachelor of technology)/.test(raw)) return "be_btech";
  if (/(post graduate|postgraduation|post graduation|master|mba|mca|m tech|mtech|msc|m sc)/.test(raw)) return "post_graduate";
  if (/(graduate|graduation|bachelor|bsc|b sc|bcom|b com|ba |b a )/.test(raw)) return "graduate";
  if (/diploma/.test(raw)) return "diploma";
  if (/\biti\b/.test(raw)) return "iti";
  if (/(12th|hsc|higher secondary)/.test(raw)) return "12th";
  if (/(10th|ssc|secondary)/.test(raw)) return "10th";
  if (/(8th|9th|below 10th|under 10th)/.test(raw)) return "below_10th";

  return "";
};

const findExperienceOption = (rawValue, options = []) => {
  const raw = normalizeMappedText(rawValue);
  if (!raw) return "";

  const direct = options.find((option) => {
    const optionValue = normalizeMappedText(option.value);
    const optionLabel = normalizeMappedText(option.label);
    return raw === optionValue || raw === optionLabel || raw.includes(optionValue) || raw.includes(optionLabel);
  });
  if (direct) return direct.value;

  if (/fresher|no experience/.test(raw)) return "Fresher";
  if (/<\s*1|less than 1|0 5|0 year|0 years/.test(raw)) return "<1 year";

  const numberMatch = raw.match(/(\d+(\.\d+)?)/);
  if (!numberMatch) return "";
  const years = parseFloat(numberMatch[1]);

  if (years < 1) return "<1 year";
  if (years < 2) return "1-2 years";
  if (years < 3) return "2-3 years";
  if (years < 4) return "3-4 years";
  if (years < 5) return "4-5 years";
  if (years < 7) return "5-7 years";
  if (years < 10) return "7-10 years";
  if (years < 15) return "10+ years";
  return "15+ years";
};

const getOptionLabel = (options = [], value) => {
  const found = options.find((option) => option.value === value);
  return found ? found.label : value || "-";
};

const normalizeDateForInput = (rawValue) => {
  const raw = String(rawValue || "").trim();
  if (!raw) return "";

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return raw;
  }

  const dashMatch = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (dashMatch) {
    const [, dd, mm, yyyy] = dashMatch;
    return `${yyyy}-${mm}-${dd}`;
  }

  const slashMatch = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (slashMatch) {
    const [, dd, mm, yyyy] = slashMatch;
    return `${yyyy}-${mm}-${dd}`;
  }

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toISOString().split("T")[0];
  }

  return "";
};

const openMappedCasesModal = async () => {
  setMappedCasesLoading(true);
  setMappedCasesError("");
  try {
    const response = await axios.get(
      apiurl + 'registeration.php?subdomain=react&aid=' + aid + "&aidtype=" + aidtype + "&action=mapped_cases_list"
    );
    if (response.data.status === true) {
      const nextCases = response.data.cases || [];
      const nextDrafts = {};
      nextCases.forEach((item) => {
        const rawQual = item.candidate_fields?.qual_raw || item.candidate_fields?.qual || "";
        const rawExp = item.candidate_fields?.exp_raw || item.candidate_fields?.exp || "";
        nextDrafts[item.case_id] = {
          name: item.candidate_fields?.name || item.candidate_name || "",
          mobile: item.candidate_fields?.mobile || "",
          email: item.candidate_fields?.email || "",
          profile: item.candidate_fields?.profile || "",
          age: normalizeDateForInput(item.candidate_fields?.age || ""),
          qual: findQualificationOption(rawQual, qualificationOptions),
          qualRaw: rawQual,
          exp: findExperienceOption(rawExp, experienceOptions),
          expRaw: rawExp,
          pincode: item.candidate_fields?.pincode || "",
          city: item.candidate_fields?.city || "",
          state: item.candidate_fields?.state || "",
        };
      });
      setMappedCases(nextCases);
      setMappedCaseDrafts(nextDrafts);
      setMappedCaseSelections([]);
      setExpandedMappedCaseId(null);
      setHasMappedLineupCases((response.data.count || 0) > 0);
    } else {
      setMappedCases([]);
      setMappedCaseDrafts({});
      setMappedCaseSelections([]);
      setExpandedMappedCaseId(null);
      setMappedCasesError(response.data.message || "Unable to load mapped cases");
      setHasMappedLineupCases(false);
    }
  } catch (error) {
    setMappedCases([]);
    setMappedCaseDrafts({});
    setMappedCaseSelections([]);
    setExpandedMappedCaseId(null);
    setMappedCasesError("Unable to load mapped cases");
    setHasMappedLineupCases(false);
  } finally {
    setMappedCasesLoading(false);
  }
};

const toggleMappedCaseSelection = (caseId) => {
  setMappedCaseSelections((prev) =>
    prev.includes(caseId) ? prev.filter((item) => item !== caseId) : [...prev, caseId]
  );
};

const handleMappedCaseDraftChange = (caseId, field, value) => {
  let nextValue = value;
  if (field === "mobile") {
    nextValue = value.replace(/\D/g, "").slice(0, 10);
  } else if (field === "pincode") {
    nextValue = value.replace(/\D/g, "").slice(0, 6);
  }
  setMappedCaseDrafts((prev) => ({
    ...prev,
    [caseId]: {
      ...(prev[caseId] || {}),
      [field]: nextValue,
    },
  }));
};

const toggleMappedCaseEditor = (caseId) => {
  setExpandedMappedCaseId((prev) => (prev === caseId ? null : caseId));
};

const getMappedCaseValidationErrors = (draft = {}) => {
  const errors = {};
  if (!String(draft.name || "").trim()) errors.name = "Name is required";
  if (!String(draft.mobile || "").trim()) errors.mobile = "Mobile is required";
  if (!String(draft.profile || "").trim()) errors.profile = "Profile is required";
  if (!String(draft.qual || "").trim()) errors.qual = "Qualification is required";
  if (!String(draft.exp || "").trim()) errors.exp = "Experience is required";
  return errors;
};

const hasMappedCaseValidationErrors = (draft = {}) => Object.keys(getMappedCaseValidationErrors(draft)).length > 0;

const submitMappedCaseImports = async () => {
  if (mappedCaseSelections.length === 0) {
    Swal.fire({
      position: "top-center",
      icon: "question",
      title: "Please select at least one mapped candidate",
      showConfirmButton: false,
      timer: 2000,
    });
    return;
  }

  const payload = [];
  for (const caseId of mappedCaseSelections) {
    const draft = mappedCaseDrafts[caseId] || {};
    if (hasMappedCaseValidationErrors(draft)) {
      Swal.fire({
        position: "top-center",
        icon: "warning",
        title: "Fill required fields",
        text: "Name, Mobile, Profile, Qualification, and Experience are required for selected candidates.",
      });
      setExpandedMappedCaseId(caseId);
      return;
    }

    payload.push({
      case_id: caseId,
      ...draft,
    });
  }

  try {
    setMappedCasesImporting(true);
    $("#showLoader").removeClass("d-none").addClass("d-flex");
    const formData = new FormData();
    formData.append("subdomain", "react");
    formData.append("aid", aid);
    formData.append("aidtype", aidtype);
    formData.append("action", "import_mapped_cases");
    formData.append("selected_cases", JSON.stringify(payload));

    const response = await axios.post(apiurl + "registeration.php", formData);
    if (response.data?.status === true) {
      const skippedCount = Array.isArray(response.data.skipped) ? response.data.skipped.length : 0;
      Swal.fire({
        position: "top-center",
        icon: "success",
        title: response.data.message || "Mapped candidates added successfully",
        text: skippedCount > 0 ? `${response.data.inserted || 0} added, ${skippedCount} skipped.` : undefined,
        showConfirmButton: true,
      }).then(() => {
        $("#mappedCasesModal .btn-close").click();
        fetchData(currentPage);
        openMappedCasesModal();
      });
    } else {
      const skippedMessages = Array.isArray(response.data?.skipped)
        ? response.data.skipped
            .map((item) => item?.reason)
            .filter((reason, index, arr) => reason && arr.indexOf(reason) === index)
        : [];
      Swal.fire({
        position: "top-center",
        icon: "error",
        title: response.data?.message || "Unable to add mapped candidates",
        text: skippedMessages.length > 0 ? skippedMessages.join(" | ") : undefined,
        showConfirmButton: true,
      });
    }
  } catch (error) {
    Swal.fire({
      position: "top-center",
      icon: "error",
      title: "Unable to add mapped candidates",
      text: error.response?.data?.message || error.message,
      showConfirmButton: true,
    });
  } finally {
    setMappedCasesImporting(false);
    $("#showLoader").removeClass("d-flex").addClass("d-none");
  }
};

const checkMappedCasesAvailability = async () => {
  try {
    const response = await axios.get(
      apiurl + 'registeration.php?subdomain=react&aid=' + aid + "&aidtype=" + aidtype + "&action=mapped_cases_list"
    );
    if (response.data.status === true) {
      setHasMappedLineupCases((response.data.count || 0) > 0);
    } else {
      setHasMappedLineupCases(false);
    }
  } catch (error) {
    setHasMappedLineupCases(false);
  }
};

const openExtDetail = async (id) => {
  setExtDetailId(id);
  setExtDetailData(null);
  setExtDetailLoading(true);
  try {
    const res = await axios.get(apiurl + 'external_candidate.php?action=get_one&id=' + id);
    setExtDetailData(res.data);
  } catch {
    setExtDetailData({ ok: false, error: 'Failed to load.' });
  } finally {
    setExtDetailLoading(false);
  }
};

const fetchExternalCandidates = async () => {
  setExternalLoading(true);
  setExternalError('');
  try {
    const res = await axios.get(
      apiurl + 'external_candidate.php?action=list&requirement_id=' + aid
    );
    setExternalCandidates(Array.isArray(res.data?.candidates) ? res.data.candidates : []);
  } catch (err) {
    setExternalError('Failed to load external candidates.');
  } finally {
    setExternalLoading(false);
  }
};

const fetchUnassignedCandidates = async () => {
  setExternalLoading(true);
  setExternalError('');
  try {
    const res = await axios.get(
      apiurl + 'external_candidate.php?action=list&unassigned=1'
    );
    setExternalCandidates(Array.isArray(res.data?.candidates) ? res.data.candidates : []);
  } catch (err) {
    setExternalError('Failed to load unassigned candidates.');
  } finally {
    setExternalLoading(false);
  }
};

const approveExternalCandidates = async () => {
  if (!selectedExternal.length) return;
  setExternalApproving(true);
  try {
    const fd = new FormData();
    fd.append('action', 'approve');
    selectedExternal.forEach(id => fd.append('ids[]', id));
    if (externalView === 'unassigned') {
      fd.append('assign_requirement_id', aid);
    }
    const res = await axios.post(apiurl + 'external_candidate.php', fd);
    if (res.data?.ok) {
      Swal.fire({ icon: 'success', title: res.data.message || 'Candidates added.', position: 'top-center', showConfirmButton: true });
      setSelectedExternal([]);
      if (externalView === 'unassigned') {
        fetchUnassignedCandidates();
      } else {
        fetchExternalCandidates();
      }
      fetchData(1);
    } else {
      Swal.fire({ icon: 'error', title: res.data?.error || 'Approval failed.', position: 'top-center' });
    }
  } catch (err) {
    Swal.fire({ icon: 'error', title: 'Request failed.', position: 'top-center' });
  } finally {
    setExternalApproving(false);
  }
};

const fetchData = async (page) => {
  const response = await axios.get(apiurl+'registeration.php?subdomain=react&aid='+aid+"&aidtype="+aidtype+"&page="+page); // Replace with your API endpoint
 
   setStaff(response.data.vendor);
   setStaff2(response.data.staffs);
   setTotalRows(response.data.total_count);
   setExper(response.data.exper);
   setQual(response.data.quals);
   setStats(response.data.stats);
   setLatestLineupId(response.data.latest_lineup_id || "");

   setRecruiter(response.data.recruiter);
   setGroupedData(response.data.requirements || [])
 
   setMetaData({
  appname: response.data.appname,
  edit: response.data.edit,
  del: response.data.del,
  add: response.data.add,
  view: response.data.view,
  typess:response.data.typess,
  icon:response.data.icon,
  defaultShow:response.data.defaultShow,
  checkbox:response.data.checkbox
   });

 setTotal(response.data.total);
 setTableLoading(false);

};


const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});

const [fileInfo, setFileInfo] = useState(null);

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

useEffect(() => {
  document.title = aidtype==='10' ? "Self line up Candidate | MERAQUI" : (aidtype==='301' || aidtype=='302' ? (aidtype==='301'? 'Open Campaign Line up' : 'Paid Campaign Line up') : (aidtype==='202' ? 'CAMPAIGN CANDIDATE': 'Candidates | MERAQUI'));
    fetchData(currentPage);
  $('#modalclose').on('click', function () {
    $("#hidden").val("");
    $("#reset").click();
    setFileType(null);
    setFileUrl(null);
    checks('1');
});

}, [refreshKey,aid,aidtype,currentPage]);

useEffect(() => {
  const canSeeMappedCases = (aidtype === '10' || aidtype === '202') && (
    String(metaData.typess || '').toUpperCase() === 'ADMIN' || metaData.add === 1
  );

  if (canSeeMappedCases) {
    checkMappedCasesAvailability();
  } else {
    setHasMappedLineupCases(false);
  }
}, [aid, aidtype, metaData.add, metaData.typess]);

useEffect(() => {
  if (aidtype === '2') {
    setShowVendor(true);
  }

  if (showVendor && showRecruiter) {
    setFilteredStaff([...vendorCandidates, ...recruiterCandidates]);
  } else if (showVendor) {
    setFilteredStaff(vendorCandidates);
  } else if (showRecruiter) {
    setFilteredStaff(recruiterCandidates);
  } else {
    setFilteredStaff([...vendorCandidates, ...recruiterCandidates]);
  }

}, [showVendor, showRecruiter, vendorCandidates, recruiterCandidates]);

useEffect(() => {
  if (activeTab === "vendor" && aidtype===3) {
    setSelectedRows([]);
  }
}, [activeTab]);

const handleSelectAll = (checked) => {
    if (checked) {
        // Select all rows currently visible/processed
        const allIds = processedData.map(row => row.id);
        setSelectedRows(allIds);
    } else {
        // Deselect all
        setSelectedRows([]);
    }
};

  const handleRowSelect = (id, checked) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };

const stableSort = (array, comparator) => {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
              return order;
          }
          return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
  };
  
  const getComparator = (order, orderBy) => {
      return order === 'desc'
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
  };
  
  const descendingComparator = (a, b, orderBy) => {
      const valA = orderBy(a);
      const valB = orderBy(b);
  
      if (valB < valA) {
          return -1;
      }
      if (valB > valA) {
          return 1;
      }
      return 0;
  };
  
  
  const ColumnHeaderWithFilter = ({ 
      column, 
      orderBySelector, 
      order, 
      handleRequestSort, 
      columnFilters, 
      setColumnFilters,
      
  }) => {
     const [localOpenKey, setLocalOpenKey] = useState(null);
     const [anchorEl, setAnchorEl] = useState(null);
      const accessorKey = column.accessorKey;
     
     const isMenuOpen = localOpenKey === accessorKey; // <--- NEW WAY
      const currentFilter = String(columnFilters[accessorKey] || ''); 
      const isSorted = orderBySelector === column.selector;
  
      const handleClick = (event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
          setLocalOpenKey(accessorKey);
      };
  
      const handleClose = () => {
          setAnchorEl(null);
          setLocalOpenKey(null);
      };
  
      const handleFilterChange = (e) => {
          setColumnFilters(prev => ({
              ...prev,
              [accessorKey]: e.target.value
          }));
      };
      
      const isSortable = !!column.selector;
      const isFilterable = !!column.filterType;
  
  
      // --- Custom Filter Input Renderer ---
      const renderFilterInput = () => {
          if (column.filterType === 'select') {
              // Use the dynamically derived filterOptions attached to the column object
              const filterOptions = column.dynamicFilterOptions || [];
              
              return (
                  <MuiSelect
                      label={`Filter ${column.header}`}
                      variant="outlined"
                      size="small"
                      value={currentFilter}
                      onChange={handleFilterChange}
                      sx={{ width: '100%' }}
                  >
                      {/* Default option to show all values */}
                      <MenuItem value="">— All —</MenuItem>
                      {filterOptions.map(option => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                  </MuiSelect>
              );
          }
  
          if (column.filterType === 'date') {
              return (
                  <TextField
                      label={`Filter ${column.header}`}
                      type="date" 
                      variant="outlined"
                      size="small"
                      value={currentFilter}
                      onChange={handleFilterChange}
                      // This ensures the label is correctly positioned for date input
                      InputLabelProps={{ shrink: true }} 
                      sx={{ width: '100%' }}
                  />
              );
          }
  
          // Default: text filter
          return (
              <TextField
                  label={`Filter ${column.header}`}
                  variant="outlined"
                  size="small"
                  value={currentFilter}
                  onChange={handleFilterChange}
                  autoFocus
                  sx={{ width: '100%' }}
              />
          );
      };
  
  
      return (
          <Box 
              sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  width: '100%', 
                  '& .MuiTableSortLabel-root': { flexGrow: 1 } 
              }}
          >
              <TableSortLabel
                  active={isSorted}
                  direction={isSorted ? order : 'asc'}
                  onClick={() => isSortable && handleRequestSort(column.selector)}
                  IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                  sx={{ 
                      cursor: isSortable ? 'pointer' : 'default',
                      justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                      '&.Mui-active': {
                          color: 'primary.main',
                          fontWeight: 'bold',
                      }
                  }}
              >
                  {column.header}
              </TableSortLabel>
  
              {isFilterable && (
                  <>
                      <IconButton
                          aria-label="filter"
                          size="small"
                          onClick={handleClick}
                          sx={{ 
                              ml: 1, 
                              p: 0,
                              color: currentFilter ? 'primary.main' : 'text.secondary',
                          }}
                      >
                          <MoreVertIcon fontSize="inherit" />
                      </IconButton>
                      <Menu
                          anchorEl={anchorEl}
                          open={isMenuOpen}
                          onClose={handleClose}
                          onClick={(e) => e.stopPropagation()} 
                          PaperProps={{
                              sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                          }}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                      >
                          <Box sx={{ width: '100%', p: 1 }}>
                              {renderFilterInput()}
                          </Box>
                          
                          {/* Clear filter button */}
                          {currentFilter && (
                               <Button
                                  onClick={() => {
                                      setColumnFilters(prev => ({ ...prev, [accessorKey]: '' }));
                                      handleClose();
                                  }}
                                  size="small"
                                  color="error"
                                  sx={{ mt: 1, textTransform: 'none' }}
                              >
                                  Clear Filter
                              </Button>
                          )}
                      </Menu>
                  </>
              )}
          </Box>
      );
  };

  const currentRows = aidtype === '3' ? (activeTab === 'recruiter' ? recruiterCandidates : vendorCandidates)  : (showRecruiter && !showVendor ? recruiterCandidates : showVendor && !showRecruiter ? vendorCandidates : filteredStaff);
const primaryCount=currentRows.length; 
const secondaryCount=vendorCandidates.length;
const warningCount=recruiterCandidates.length; 

 const dynamicFilterOptions = useMemo(() => {
            const options = {};
            const selectAccessors = ['profile','type','lineup_type'];
            
            selectAccessors.forEach(key => {
                const uniqueValues = new Set();
                currentRows.forEach(row => {
                    if (row[key]) {
                        uniqueValues.add(row[key]);
                    }
                });
                options[key] = Array.from(uniqueValues).sort();
            });
            return options;
        }, [currentRows]);
  

  const BASE_COLUMNS_DEFINITION = [
    { accessorKey: 'date', selector: (row) => row.date, filterType: 'date' },
              ...(aidtype === '10' ? [{ accessorKey: 'lineup_type', selector: (row) => row.lineup_type, filterType: 'select', dynamicFilterOptions: dynamicFilterOptions['lineup_type'] }] : []),
              { accessorKey: 'name', selector: (row) => row.name, filterType: 'text' },
              { accessorKey: 'mobile',  selector: (row) => row.mobile, filterType: 'text' },
              { accessorKey: 'profile', selector: (row) => row.profile, filterType: 'select', dynamicFilterOptions:dynamicFilterOptions['profile'] },
               { 
                  accessorKey: 'email', 
                  selector: (row) => row.email, 
                  filterType: 'text',
              },
];

  
 const processedData = useMemo(() => {
          let filtered = currentRows;
          const lowerCaseFilter = globalFilterText.toLowerCase();
  
          // 1. Apply Global Filter
          if (lowerCaseFilter) {
              filtered = filtered.filter(row => 
                  BASE_COLUMNS_DEFINITION.some(column => {
                      const value = column.selector ? String(column.selector(row)) : '';
                      return value.toLowerCase().includes(lowerCaseFilter);
                  })
              );
          }
  
          // 2. Apply Column Filters
          filtered = filtered.filter(row => {
              return BASE_COLUMNS_DEFINITION.every(column => {
                  const accessorKey = column.accessorKey;
                  const filterValue = columnFilters[accessorKey];
  
                  if (!filterValue) return true;
                  if (!column.selector) return true;
  
                  const rowValue = String(column.selector(row));
  
                  switch (column.filterType) {
                      case 'select':
                          // Must match the selected value exactly
                          return rowValue === filterValue; 
                          
                      case 'date':
                          // Check if the date string (e.g., '2024-01-15') includes the filter date
                          return rowValue.includes(filterValue); 
                          
                      case 'text':
                      default:
                          return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                  }
              });
          });
  
          // 3. Sorting Logic
          const sortColumn = BASE_COLUMNS_DEFINITION.find(col => col.selector === orderBySelector);
  
          if (sortColumn) {
              return stableSort(filtered, getComparator(order, sortColumn.selector));
          }
          
          return filtered;
  
 }, [currentRows, BASE_COLUMNS_DEFINITION, order, orderBySelector, globalFilterText, columnFilters]);
 
 const isAllSelected = processedData.length > 0 && selectedRows.length === processedData.length;
const isIndeterminate = selectedRows.length > 0 && !isAllSelected;


const columns = useMemo(() => {
          let baseColumns = [
                 { 
                    accessorKey: 'select', 
                    size: 10, 
                    header: (
                        <Checkbox
                            color="primary"
                            indeterminate={isIndeterminate}
                            checked={isAllSelected}
                            onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                    ),
                    Cell: ({ row: { original: row } }) => {
                        return (
                            <Checkbox 
                                color="primary"
                                checked={selectedRows.includes(row.id)}
                                onChange={(e) => {
                                    e.stopPropagation(); 
                                    handleRowSelect(row.id, e.target.checked);
                                }}
                            />
                        );
                    }
                },
              { accessorKey: 'date', header: 'Date Time', size: 150, selector: (row) => row.date, filterType: 'date' },
              ...(aidtype === '10' ? [{ 
                  accessorKey: 'lineup_type', 
                  header: 'Lineup Type', 
                  size: 150, 
                  selector: (row) => row.lineup_type, 
                  filterType: 'select',
                  dynamicFilterOptions: dynamicFilterOptions['lineup_type']
              }] : []),
              { accessorKey: 'name', header: 'Name', size: 150, selector: (row) => row.name, filterType: 'text' },
              { accessorKey: 'mobile', header: 'Mobile', size: 150, selector: (row) => row.mobile, filterType: 'text' },
              { accessorKey: 'profile', header: 'Profile', size: 150, selector: (row) => row.profile, filterType: 'select', dynamicFilterOptions:dynamicFilterOptions['profile'] },
               { 
                  accessorKey: 'email', 
                  header: 'Email', 
                  size: 150, 
                  selector: (row) => row.email, 
                  filterType: 'text',
              },
              { 
                  accessorKey: 'utype', 
                  header: 'Upload type', 
                  size: 150, 
                  selector: (row) => row.type, 
                  filterType: 'select',
                  dynamicFilterOptions: dynamicFilterOptions['type']
              }
  
          ];
         return baseColumns;
}, [dynamicFilterOptions,selectedRows, handleRowSelect, handleSelectAll, isAllSelected, isIndeterminate, aidtype]);
  
 const handleRequestSort = useCallback((selector) => {
          const isAsc = orderBySelector === selector && order === 'asc';
          setOrder(isAsc ? 'desc' : 'asc');
          setOrderBySelector(() => selector);
 }, [order, orderBySelector]);

// form submit in category
const FormSubmit = async (e) =>{
          e.preventDefault();
    const form = $("#mainForm")[0];

  const requiredFields = form.querySelectorAll("[required]");

  for (let field of requiredFields) {

    if(!field.value || field.value.trim() === ""){

      const label = form.querySelector(`label[for="${field.id}"]`);

      const fieldName = label ? label.innerText.replace("*","").trim() : field.name;

      Swal.fire({
        icon:"warning",
        title:"Missing Field",
        text:`Please fill in ${fieldName}`
      });

      field.focus();
      return;
    }

  }
  if(!filters.qual){
    Swal.fire({
      icon:"warning",
      title:"Please select Qualification"
    });
    return;
  }

  if(!filters.exp){
    Swal.fire({
      icon:"warning",
      title:"Please select Experience"
    });
    return;
  }
          // try and catch method
            try {
              const formData = new FormData(form);
              formData.append("qual",filters.qual);
              formData.append("exp",filters.exp);
              
             $("#showLoader").removeClass('d-none').addClass('d-flex');
               const response = await axios.post(apiurl + "registeration.php", formData);
              if (response.data.status==true) {
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                           Swal.fire({
                             position: "top-center",
                             icon: "success",
                             title: response.data.message,
                             showConfirmButton: false,
                             timer: 2000
                          }).then(()=>{
                            $(".btn-close").click();
                            fetchData(currentPage);
                            $("#mainForm input").val("");
                            handleSelectChange("qual",null);
                            handleSelectChange("exp",null);
                        });
              }
              else{
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.message,
                  showConfirmButton: true,
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                  allowEscapeKey: false
                });
              }
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
            finally {
                $("#loader").css("display", "none");
            }
};

function checks(dd){
  if(dd=='1'){
       $("#mainForm input, #mainForm select").attr("required",true);
        $("#mainForm input[type=file]").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",false);
         $("#mainForm .btn-primary, #resumelabel").show();
  }
  else{
        $("#mainForm input, #mainForm select").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",true);
         $("#mainForm .btn-primary, #resumelabel").hide();
  }
}


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setFileUrl(url);
    setFileType(file.type);
  };

const BulkUploadResultsModal = ({ show, onClose, results = {} }) => {
    const safeResults = results || {};
    const { alreadyExist = [], duplicate = [], unique = [] } = safeResults;

    useEffect(() => {
      if (show) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return () => (document.body.style.overflow = "");
    }, [show]);

    if (!show) return null;

    const SummaryRow = ({ label, count, colorClass }) => (
      <div className="me-3 d-flex align-items-center">
        <span
          className={`badge ${colorClass} rounded-pill me-2`}
          style={{ minWidth: 28 }}
        >
          {count}
        </span>
        <small className="text-muted">{label}</small>
      </div>
    );

    const Table = ({ title, items, emptyMessage }) => (
      <div className="mb-3">
        <h6 className="mb-2">
          {title} <small className="text-muted">({items.length})</small>
        </h6>
        <div className="table-responsive" style={{ maxHeight: "360px", overflowY: "auto" }}>
          <table className="table table-hover table-sm align-middle">
            <thead className="table-light sticky-top">
              <tr>
                <th style={{ width: "6%" }}>#</th>
                <th style={{ width: "34%" }}>Name</th>
                <th style={{ width: "24%" }}>Mobile</th>
                <th style={{ width: "30%" }}>Email</th>
                <th style={{ width: "6%" }} className="text-end">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-4">
                    {emptyMessage}
                  </td>
                </tr>
              ) : (
                items.map((it, idx) => (
                  <tr key={`${it.mobile}-${idx}`}>
                    <td>{idx + 1}</td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 220,
                      }}
                      title={it.name}
                    >
                      {it.name || "-"}
                    </td>
                    <td>{it.mobile || "-"}</td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 260,
                      }}
                      title={it.email}
                    >
                      {it.email || "-"}
                    </td>
                    <td className="text-end">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => navigator.clipboard?.writeText(it.mobile || "")}
                        title="Copy mobile"
                      >
                        Copy
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );

    return (
      <>
      <div className="bulk-results-modal">
        <div className="modal-backdrop fade show"></div>
        <div className="modal d-block fade show" tabIndex={-1} role="dialog" aria-modal="true">
          <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div className="modal-content shadow-lg rounded-3">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title">Bulk Upload — Results</h5>
                  <div className="d-flex mt-1">
                    <SummaryRow label="Added (unique)" count={unique.length} colorclassName="bg-success text-white" />
                    <SummaryRow label="Duplicates in CSV" count={duplicate.length} colorclassName="bg-warning text-dark" />
                    <SummaryRow label="Already in Database" count={alreadyExist.length} colorclassName="bg-secondary text-white" />
                  </div>
                </div>
                <div>
                  <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                </div>
              </div>

              <div className="modal-body">
                <ul className="nav nav-tabs mb-3" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" data-bs-target="#added" id="tab-added" data-bs-toggle="tab" type="button" role="tab" aria-controls="added" aria-selected="true">Added</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-duplicate" data-bs-target="#duplicate" data-bs-toggle="tab" type="button" role="tab" aria-controls="duplicate" aria-selected="false">Duplicates</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-already" data-bs-target="#already" data-bs-toggle="tab" type="button" role="tab" aria-controls="already" aria-selected="false">Already in DB</button>
                  </li>
                </ul>

                <div className="tab-content">
                  <div className="tab-pane fade show active" id="added" role="tabpanel" aria-labelledby="tab-added" style={{overflowX:'auto'}}>
                    <Table title="Unique / Inserted into database" items={unique} emptyMessage="No new records were inserted." />
                  </div>
                  <div className="tab-pane fade" id="duplicate" role="tabpanel" aria-labelledby="tab-duplicate"  style={{overflowX:'auto'}}>
                    <Table title="Duplicates found in CSV (skipped)" items={duplicate} emptyMessage="No duplicate mobiles found in CSV." />
                  </div>
                  <div className="tab-pane fade" id="already" role="tabpanel" aria-labelledby="tab-already"  style={{overflowX:'auto'}}>
                    <Table title="Already present in database (skipped)" items={alreadyExist} emptyMessage="No existing mobiles found in DB." />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div className="me-auto text-muted small">
                  Total rows shown: {unique.length + duplicate.length + alreadyExist.length}
                </div>
                <button className="btn btn-outline-secondary" onClick={() => {
                  const allRows = [
                    ["type", "name", "mobile", "email"],
                    ...unique.map((i) => ["added", i.name, i.mobile, i.email]),
                    ...duplicate.map((i) => ["duplicate", i.name, i.mobile, i.email]),
                    ...alreadyExist.map((i) => ["already", i.name, i.mobile, i.email]),
                  ];
                  const csv = allRows.map(r => r.map(c => '"' + String(c || "").replace(/\"/g,'""') + '"').join(',')).join('\n');
                  const blob = new Blob([csv], { type: 'text/csv' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'bulk-upload-results.csv';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  URL.revokeObjectURL(url);
                }}>Download CSV</button>
                <button className="btn btn-primary" onClick={onClose}>Close</button>
              </div>
            </div>
          </div>
        </div>

        {newloading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <style jsx>{`
          .modal-backdrop { z-index: 1040; }
          .modal { z-index: 1050; }
          .table thead.sticky-top { top: 0; }
          .loader-overlay {
            position: fixed;
            top:0; left:0; right:0; bottom:0;
            background: rgba(255,255,255,0.7);
            display:flex;
            justify-content:center;
            align-items:center;
            z-index:2000;
          }
        `}</style>
      </div>
    </>
  );

  };

// form submit in category
const BulkFormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#bulkform")[0]);
              if($("#bulk").val().length==0){
                Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the bulk candidate file"
                   });
                   return false;
              }
              
              $("#showLoader").removeClass("d-none").addClass("d-flex");
              const response = await axios.post(apiurl + "registeration.php", formData);
              if (response.data.status === true) {

  setResults({
  alreadyExist: response.data.already || [],
  duplicate: response.data.duplicate || [],
  unique: response.data.unique || []
});
      setShowResultsModal(true);

      $("#modalclose2").click();
      $("#bulkform input").val("");
      fetchData(currentPage);

               }
              else{
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.messages,
                  showConfirmButton: true,
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                  allowEscapeKey: false
                });
              }
               $("#showLoader").removeClass("d-flex").addClass("d-none");
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
};

 if (newloading) {
    
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

const RecruiterForm = async (e) => {
  e.preventDefault();

  if (selectedRecruiter === null) {
    Swal.fire({
      position: "top-center",
      icon: 'question',
      title: "Please select Recruiter",
      showConfirmButton: false,
      timer: 2000,
    })
    return false;
  }

  const ids = selectedRows.join(",");

  try {
    $("#showLoader").removeClass("d-none").addClass("d-flex"); // show loader
    const formData = new FormData();
    formData.append("value", ids);
     formData.append("person", selectedRecruiter);
     formData.append("aid",aid);
     formData.append("formType",aidtype);

    const response = await axios.post(apiurl + "allotement.php",formData);

    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader

    Swal.fire({
      position: "top-center",
      icon: response.data.icon,
      title: response.data.message,
      showConfirmButton: false,
      timer: 2000,
    }).then(() => {
      $("#RecruiterModal .btn-close").click();
       fetchData(currentPage);
      selectRecruiter(null);
      setSelectedRows([]); // clear all
    });
  } catch (error) {
    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader on error
    Swal.fire({
      position: "top-center",
      icon: "error",
      title: "Something went wrong!",
      text: error.message,
    });
  }
};

const SendForApproval =  async () =>{
  if (isSubmittingRequest) return;

  if (selectedRows === null) {
    Swal.fire({
      position: "top-center",
      icon: 'question',
      title: "Please select at least one checkbox",
      showConfirmButton: false,
      timer: 2000,
    })
    return false;
  }

  const ids = selectedRows.join(",");

  try {
    setIsSubmittingRequest(true);
    $("#showLoader").removeClass("d-none").addClass("d-flex"); // show loader
    const formData = new FormData();
    formData.append("value", ids);
     formData.append("person", selectedRecruiter);
     formData.append("aid",aid);
     formData.append("formType",aidtype);

    const response = await axios.post(apiurl + "allotement.php",formData);
    
    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader
    Swal.fire({
      position: "top-center",
      icon: response.data.icon,
      title: response.data.message,
      showConfirmButton: false,
      timer: 2000,
    }).then(() => {
       fetchData(currentPage);
      setSelectedRows([]); // clear all
    });
  } catch (error) {
    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader on error
    Swal.fire({
      position: "top-center",
      icon: "error",
      title: "Something went wrong!",
      text: error.message,
    });
  } finally {
    setIsSubmittingRequest(false);
  }
};

const IvrFORM = async (e) =>{
       e.preventDefault();
       $("#showLoader").removeClass('d-none').addClass('d-flex');
     
    try {
      const formData = new FormData($("#submitform")[0]);
      formData.append("aid",aid);
      formData.append("aidtype",aidtype);
      formData.append("candidates",candidatesId);
      const response = await axios.post(apiurl + "line.php", formData);
      
      if (response.data.status === true) {
      
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          fetchData(currentPage);
          $(".offcanvas .btn-close").click();
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: true,
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

const candidatecolumns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Mobile", selector: (row) => row.mobile, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Profile", selector: (row) => row.profile, sortable: true },
];

const updateDetails = async (idd,val) => { 
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       
       try{
        const formdate = new FormData();
        formdate.append("com",idd);
        formdate.append("value",val);
        formdate.append("candidates",selectedRows);
        const response = await axios.post(apiurl + 'line.php',formdate);
       
         if(response.data.status === true){
            $("#tera_modal3").click();

            setIvr(idd);
            setIvrData(response.data.main[0]);
            
            setCandidates(response.data.candidates);
            setCandidatesId(response.data.candidates.map(c => c.candidateid));
         }
         else{
                  Swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Something Went Wrong !",
                    showConfirmButton: false,
                    timer: 2000
                  }).then(()=>{
                     fetchData(currentPage);
                  });
         }
       }
       catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
       }
       finally {
         $("#showLoader").removeClass('d-flex').addClass('d-none');
       }
};


const handleFileChange2 = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileInfo({
      name: file.name,
      size: (file.size / 1024).toFixed(2) // KB
    });
  };

return(
<>
<div className="modal effect-super-scaled fade" id="mappedCasesModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="mappedCasesModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "96vw", width: "96vw" }}>
    <div className="modal-content">
      <div className="modal-header">
        <div>
          <h5 className="modal-title" id="mappedCasesModalLabel">Mapped Case Candidates</h5>
          <small className="text-muted">
            Select {(aidtype === '202' ? 'campaign' : 'lineup')} cases and edit only the candidate fields needed for add candidate.
          </small>
        </div>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {mappedCasesLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : mappedCasesError ? (
          <div className="alert alert-danger mb-0">{mappedCasesError}</div>
        ) : mappedCases.length === 0 ? (
          <div className="alert alert-info mb-0">No mapped case candidates found yet.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle mb-0">
              <thead className="table-light sticky-top">
                <tr>
                  <th style={{ width: "70px" }}>Select</th>
                  <th>Sno.</th>
                  <th>Candidate Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Profile</th>
                  <th>DOB</th>
                  <th>Qualification</th>
                  <th>Experience</th>
                  <th>Pincode</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {mappedCases.map((item, index) => {
                  const draft = mappedCaseDrafts[item.case_id] || {};
                  const isExpanded = expandedMappedCaseId === item.case_id;
                  const isSelected = mappedCaseSelections.includes(item.case_id);
                  const validationErrors = getMappedCaseValidationErrors(draft);

                  return (
                    <React.Fragment key={item.case_id || index}>
                      <tr
                        onClick={() => toggleMappedCaseSelection(item.case_id)}
                        style={{
                          cursor: "pointer",
                          backgroundColor: isSelected ? "rgba(13, 110, 253, 0.08)" : undefined,
                        }}
                      >
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => toggleMappedCaseSelection(item.case_id)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>{draft.name || '-'}</td>
                        <td>{draft.mobile || '-'}</td>
                        <td>{draft.email || '-'}</td>
                        <td>{draft.profile || '-'}</td>
                        <td>{draft.age || '-'}</td>
                        <td>{getOptionLabel(qualificationOptions, draft.qual)}</td>
                        <td>{getOptionLabel(experienceOptions, draft.exp)}</td>
                        <td>{draft.pincode || '-'}</td>
                        <td>{draft.city || '-'}</td>
                        <td>{draft.state || '-'}</td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleMappedCaseEditor(item.case_id);
                            }}
                            title="Edit candidate fields"
                          >
                            <EditOutlined fontSize="small" />
                          </button>
                        </td>
                      </tr>
                      {isExpanded && (
                        <tr className="table-light">
                          <td colSpan="13">
                            <div className="p-2">
                              <div className="row g-3">
                                <div className="col-md-4">
                                  <label className="form-label">Name</label>
                                  <input
                                    type="text"
                                    className={`form-control ${validationErrors.name ? "is-invalid" : ""}`}
                                    value={draft.name || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "name", e.target.value)}
                                  />
                                  {validationErrors.name ? <div className="text-danger small mt-1">{validationErrors.name}</div> : null}
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Mobile</label>
                                  <input
                                    type="text"
                                    className={`form-control ${validationErrors.mobile ? "is-invalid" : ""}`}
                                    maxLength={10}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={draft.mobile || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "mobile", e.target.value)}
                                  />
                                  {validationErrors.mobile ? <div className="text-danger small mt-1">{validationErrors.mobile}</div> : null}
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    value={draft.email || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "email", e.target.value)}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Profile</label>
                                  <input
                                    type="text"
                                    className={`form-control ${validationErrors.profile ? "is-invalid" : ""}`}
                                    value={draft.profile || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "profile", e.target.value)}
                                  />
                                  {validationErrors.profile ? <div className="text-danger small mt-1">{validationErrors.profile}</div> : null}
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Date of Birth</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    value={draft.age || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "age", e.target.value)}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Qualification</label>
                                  <Select
                                    options={qualificationOptions}
                                    placeholder="Select Qualification"
                                    isSearchable={true}
                                    value={qualificationOptions.find((option) => option.value === draft.qual) || null}
                                    onChange={(selected) => handleMappedCaseDraftChange(item.case_id, "qual", selected ? selected.value : "")}
                                  />
                                  {validationErrors.qual ? <div className="text-danger small mt-1">{validationErrors.qual}</div> : null}
                                  {draft.qualRaw ? (
                                    <small className="text-muted d-block mt-1">OCR value: {draft.qualRaw}</small>
                                  ) : null}
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Experience</label>
                                  <Select
                                    options={experienceOptions}
                                    placeholder="Select Experience"
                                    isSearchable={true}
                                    value={experienceOptions.find((option) => option.value === draft.exp) || null}
                                    onChange={(selected) => handleMappedCaseDraftChange(item.case_id, "exp", selected ? selected.value : "")}
                                  />
                                  {validationErrors.exp ? <div className="text-danger small mt-1">{validationErrors.exp}</div> : null}
                                  {draft.expRaw ? (
                                    <small className="text-muted d-block mt-1">OCR value: {draft.expRaw}</small>
                                  ) : null}
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Pincode</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    maxLength={6}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={draft.pincode || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "pincode", e.target.value)}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">City</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={draft.city || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "city", e.target.value)}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">State</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={draft.state || ""}
                                    onChange={(e) => handleMappedCaseDraftChange(item.case_id, "state", e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div className="modal-footer">
        <div className="me-auto text-muted small">
          Selected: {mappedCaseSelections.length}
        </div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={submitMappedCaseImports}
          disabled={mappedCasesImporting || mappedCaseSelections.length === 0}
        >
          {mappedCasesImporting ? "Adding..." : "Add Candidates"}
        </button>
        <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<BulkUploadResultsModal show={showResultsModal} onClose={() => setShowResultsModal(false)} results={results}/>

{/* ── External Candidates Modal ── */}
{showExternalModal && (
  <div className="modal fade show" style={{ display:'block', backgroundColor:'rgba(0,0,0,0.5)', zIndex:1055 }} tabIndex="-1">
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header d-flex align-items-center gap-3">
          <h5 className="modal-title">External Candidates (Karam Bot)</h5>
          <div className="btn-group ms-2" role="group">
            <button
              type="button"
              className={`btn btn-sm ${externalView === 'pending' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => {
                if (externalView !== 'pending') {
                  setExternalView('pending');
                  setSelectedExternal([]);
                  setExternalCandidates([]);
                  fetchExternalCandidates();
                }
              }}
            >Pending</button>
            <button
              type="button"
              className={`btn btn-sm ${externalView === 'unassigned' ? 'btn-warning' : 'btn-outline-warning'}`}
              onClick={() => {
                if (externalView !== 'unassigned') {
                  setExternalView('unassigned');
                  setSelectedExternal([]);
                  setExternalCandidates([]);
                  fetchUnassignedCandidates();
                }
              }}
            >Unassigned Candidates</button>
          </div>
          <button type="button" className="btn-close ms-auto" onClick={() => { setShowExternalModal(false); setSelectedExternal([]); setExternalView('pending'); }} />
        </div>
        <div className="modal-body p-0">
          {externalLoading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
          ) : externalError ? (
            <div className="alert alert-danger m-3">{externalError}</div>
          ) : externalCandidates.length === 0 ? (
            <div className="text-center text-muted py-5">
              {externalView === 'unassigned'
                ? 'No unassigned external candidates.'
                : 'No pending external candidates for this requirement.'}
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover table-bordered mb-0" style={{ fontSize:'0.82rem' }}>
                <thead className="table-light sticky-top">
                  <tr>
                    <th style={{ width:40 }}>
                      <input type="checkbox"
                        checked={selectedExternal.length === externalCandidates.length}
                        onChange={e => setSelectedExternal(e.target.checked ? externalCandidates.map(c => c.id) : [])}
                      />
                    </th>
                    <th>Name</th><th>Mobile</th><th>Profile</th><th>DOB</th>
                    <th>Qualification</th><th>Experience</th><th>City</th><th>Email</th><th>Applied On</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {externalCandidates.map(c => (
                    <tr key={c.id} style={{ cursor:'pointer' }} onClick={() => setSelectedExternal(prev => prev.includes(c.id) ? prev.filter(x => x !== c.id) : [...prev, c.id])}>
                      <td onClick={e => e.stopPropagation()}>
                        <input type="checkbox" checked={selectedExternal.includes(c.id)}
                          onChange={e => setSelectedExternal(prev => e.target.checked ? [...prev, c.id] : prev.filter(x => x !== c.id))} />
                      </td>
                      <td><strong>{c.name}</strong></td>
                      <td>{c.mobile}</td>
                      <td>{c.profile}</td>
                      <td>{c.dob}</td>
                      <td>{c.qual}</td>
                      <td>{c.exp}</td>
                      <td>{c.city}</td>
                      <td style={{ maxWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.email}</td>
                      <td style={{ whiteSpace:'nowrap' }}>{c.created_at?.slice(0,10)}</td>
                      <td onClick={e => e.stopPropagation()}>
                        <button className="btn btn-sm btn-outline-primary" onClick={() => openExtDetail(c.id)}>
                          <i className="ri-eye-line"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer d-flex justify-content-between align-items-center">
          <span className="text-muted" style={{ fontSize:'0.85rem' }}>
            {selectedExternal.length} of {externalCandidates.length} selected
          </span>
          <div className="d-flex gap-2">
            <button className="btn btn-secondary" onClick={() => { setShowExternalModal(false); setSelectedExternal([]); setExternalView('pending'); }}>Close</button>
            <button
              className="btn btn-primary"
              disabled={!selectedExternal.length || externalApproving}
              onClick={approveExternalCandidates}
            >
              {externalApproving ? <><span className="spinner-border spinner-border-sm me-1" />Adding...</> : `Add to Campaign (${selectedExternal.length})`}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

{/* ── External Candidate Detail Modal ── */}
{extDetailId !== null && (
  <div className="modal fade show" style={{ display:'block', backgroundColor:'rgba(0,0,0,0.6)', zIndex:2000 }} onClick={() => setExtDetailId(null)}>
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" onClick={e => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{extDetailData?.candidate?.name || 'Candidate Detail'}</h5>
          <button type="button" className="btn-close" onClick={() => setExtDetailId(null)} />
        </div>
        <div className="modal-body">
          {extDetailLoading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
          ) : !extDetailData?.ok ? (
            <div className="alert alert-danger">{extDetailData?.error || 'Failed to load.'}</div>
          ) : (() => {
            const c   = extDetailData.candidate || {};
            const aad = extDetailData.aadhaar   || {};
            const res = extDetailData.resume    || {};
            const docs = extDetailData.documents || [];
            return (
              <div className="row g-3">
                <div className="col-12">
                  <div className="card custom-card mb-0">
                    <div className="card-header fw-semibold" style={{fontSize:'0.85rem'}}>Personal Information</div>
                    <div className="card-body">
                      <div className="row g-2" style={{fontSize:'0.83rem'}}>
                        {[['Name',c.name],['Mobile',c.mobile],['Email',c.email],['Profile',c.profile],
                          ['DOB',c.dob],['Qualification',c.qual],['Experience',c.exp],
                          ['City',c.city],['State',c.state],['Pincode',c.pincode],
                          ['Status',c.status],['Applied On',c.created_at?.slice(0,10)],
                        ].map(([label, val]) => val ? (
                          <div className="col-6 col-md-3" key={label}>
                            <div className="text-muted mb-1" style={{fontSize:'0.72rem'}}>{label}</div>
                            <div className="fw-semibold">{val}</div>
                          </div>
                        ) : null)}
                      </div>
                    </div>
                  </div>
                </div>
                {Object.keys(aad).length > 0 && (
                  <div className="col-md-6">
                    <div className="card custom-card mb-0 h-100">
                      <div className="card-header fw-semibold" style={{fontSize:'0.85rem'}}><i className="ri-id-card-line me-1 text-primary"></i>Aadhaar (Extracted)</div>
                      <div className="card-body" style={{fontSize:'0.82rem'}}>
                        {[['Name',aad.name],['DOB',aad.dob],['Gender',aad.gender],['Address',aad.address],['Pincode',aad.pincode],['Aadhaar No',aad.aadhaar_number]].map(([l,v]) => v ? <div key={l} className="mb-2"><span className="text-muted me-1">{l}:</span><span className="fw-semibold">{v}</span></div> : null)}
                      </div>
                    </div>
                  </div>
                )}
                {Object.keys(res).length > 0 && (
                  <div className="col-md-6">
                    <div className="card custom-card mb-0 h-100">
                      <div className="card-header fw-semibold" style={{fontSize:'0.85rem'}}><i className="ri-file-text-line me-1 text-success"></i>Resume (Extracted)</div>
                      <div className="card-body" style={{fontSize:'0.82rem'}}>
                        {[['Name',res.name],['Email',res.email],['Phone',res.phone],['Qualification',res.qualification],['Experience',res.experience]].map(([l,v]) => v ? <div key={l} className="mb-2"><span className="text-muted me-1">{l}:</span><span className="fw-semibold">{v}</span></div> : null)}
                        {res.skills && <div><div className="text-muted mb-1">Skills:</div><div className="d-flex flex-wrap gap-1">{String(res.skills).split(',').map((s,i) => <span key={i} className="badge bg-light text-dark border" style={{fontSize:'0.72rem'}}>{s.trim()}</span>)}</div></div>}
                      </div>
                    </div>
                  </div>
                )}
                {docs.length > 0 && (
                  <div className="col-12">
                    <div className="card custom-card mb-0">
                      <div className="card-header fw-semibold" style={{fontSize:'0.85rem'}}><i className="ri-attachment-line me-1 text-warning"></i>Uploaded Documents</div>
                      <div className="card-body">
                        <div className="row g-3">
                          {docs.map((doc, i) => {
                            const docUrl = apiurl + 'karambot/doc_serve.php?file=' + encodeURIComponent(doc.stored_name);
                            const isPdf = (doc.mime_type || '').includes('pdf');
                            const isImg = (doc.mime_type || '').startsWith('image/');
                            return (
                              <div key={i} className="col-12 col-md-6">
                                <div className="border rounded p-2">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <span className="fw-semibold text-truncate" style={{fontSize:'0.78rem',maxWidth:'70%'}}>{doc.original_name}</span>
                                    <a href={docUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-secondary"><i className="ri-download-line"></i></a>
                                  </div>
                                  {isPdf ? (
                                    <iframe src={docUrl} title={doc.original_name} style={{width:'100%',height:'420px',border:'none',borderRadius:'6px'}} />
                                  ) : isImg ? (
                                    <img src={docUrl} alt={doc.original_name} style={{width:'100%',maxHeight:'420px',objectFit:'contain',borderRadius:'6px'}} />
                                  ) : (
                                    <div className="text-center py-3 text-muted"><i className="ri-file-line fs-3"></i><div style={{fontSize:'0.78rem'}}><a href={docUrl} target="_blank" rel="noreferrer">Download to view</a></div></div>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {docs.length === 0 && Object.keys(aad).length === 0 && Object.keys(res).length === 0 && (
                  <div className="col-12"><div className="alert alert-secondary mb-0">No documents or extracted data available.</div></div>
                )}
              </div>
            );
          })()}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setExtDetailId(null)}>Close</button>
        </div>
      </div>
    </div>
  </div>
)}

<button data-bs-toggle="modal" id="showRecruiterModal" data-bs-target="#RecruiterModal" type="button" style={{ display: 'none' }}></button>
<button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal2" type="button" style={{ display: 'none' }}></button>

 <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal2" >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">Start LINE UP</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
         
            <form id="submitform" onSubmit={IvrFORM} encType="multipart/form-data" className='order-2'>
             <div className="row g-3">
              {(aidtype=='301' || aidtype==='302') && (
                 <div className="col-1">
                  <label htmlFor="organName" className="form-label">Campaign Id</label>
                  <input value={ivrdata.campid || ""} type="text" className="form-control" placeholder="Campaign ID" readOnly disabled/>
                </div>
              )}
              
                 <div className="col-2">
                  <label htmlFor="organName" className="form-label">Requirement Id</label>
                  <input value={ivrdata.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
                </div>
                
                <div className="col-3">
                  <label htmlFor="organName" className="form-label">Client Name</label>
                  <input value={ivrdata.client || ""} type="text" className="form-control" placeholder="Organisation name" readOnly  disabled/>
                </div>
                 <div className="col-xl-4 col-lg-3 col-md-6">
                  <label htmlFor="client" className="form-label">Designation Required</label>
                  <input  value={ivrdata.cemail || ""} type="text" className="form-control" placeholder="Designation"  readOnly  disabled/>
                </div>
                <div className="col-2">
                  <label htmlFor="skills" className="form-label">Location</label>
                  <input  value={ivrdata.location || ""}  type="text" className="form-control" placeholder="Location"  readOnly  disabled/>
                </div>
                 <div className="col-xl-6 col-lg-6 col-md-6 text-center">
                    <img src={process.env.PUBLIC_URL + "/images/media/wait.avif"} style={{ width: '60%'}} />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                    
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="pid" className="form-label"><span className='text-danger fs-15'>*</span>SPOC PERSON ID (AIP LOGIN_ID)</label>
                  <input id="pid" name="pid" type="text" className="form-control" placeholder="SPOC PERSON ID" required />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="pname" className="form-label">SPOC PERSON NAME</label>
                  <input id="pname" name="pname" type="text" className="form-control" placeholder="SPOC PERSON NAME" />
                </div>
               <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="itime" className="form-label"><span className='text-danger fs-15'>*</span>INTERVIEW TIME</label>
                  <input id="itme" name="itime" type="time" className="form-control" required/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="sdate" className="form-label"><span className='text-danger fs-15'>*</span>SELECT INTERVIEW DATE</label>
                  <input id="sdate" name="sdate" type="date" className="form-control" placeholder="Interview Date"  required/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="ldate" className="form-label"><span className='text-danger fs-15'>*</span>LINE REQUEST DATE</label>
                  <input id="ldate" name="ldate" type="datetime-local" className="form-control" placeholder="Date" required />
                </div> 
                <div className='col-12' style={{zIndex:'99999',padding: "7px 20px",textAlign: "right",position: "fixed",bottom: 0,right: 0, background: "#fff",boxShadow: "-4px -4px 4px darkgrey"}}>
                  <input type="hidden" name="hidden" value={ivr} />
                  <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </div> 

                </div>
                
           </div>
            
            </form>
          
        <div className='row'>
          <div className='col-6'>
            <h5>Line Up Candidate's</h5>
              <DataTable
          columns={candidatecolumns}
          data={candidates}
          pagination
          striped
          responsive
        />
          </div>
        </div>
        </div>

 </div>

 <div className="modal fade effect-horizontal" id="RecruiterModal" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="exampleModalLabel1" style={{ display: 'none' }} aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel1">Choose Recruiter</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
           
              <div className="modal-body">
                      <form onSubmit={RecruiterForm} >
                          
                       <div className='col-xl-12 col-lg-12 col-md-12'>
                       <label htmlFor='' className='form-label'>Select Staff</label>
                  
                  <Select
                    options={recruiter || []}   // must be an array
                    value={(recruiter || []).find(opt => opt.value == selectedRecruiter) || null}
                    onChange={(option) => selectRecruiter(option ? option.value : null)}
                    placeholder="Select Recruiter"
                  />
                  
                   </div>
                 <button type="submit" style={{marginTop:'10px',float:'right'}} className="btn btn-primary">Submit</button>
                      </form>
                     
              </div>
             
          </div>
        </div>
 </div>

<div className="offcanvas offcanvas-top" style={{maxHeight:'100%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="exampleModal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">{metaData.appname}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose"  aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   
   <div className='d-flex'>

  <form id="mainForm" onSubmit={FormSubmit} encType="multipart/form-data" className='order-2' noValidate>
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name" className="form-label">Name</label>
                      <input  id="name" name="name" className="form-control" autoComplete='off'  placeholder='Candidate Name' required />
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile" className="form-label">Mobile No.</label>
                      <input
                        id="mobile"
                        name="mobile"
                        className="form-control"
                        autoComplete='off'
                        placeholder='Mobile No.'
                        maxLength={10}
                        minLength={10}
                        inputMode='numeric'
                        pattern='[0-9]*'
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        }}
                        required
                        defaultValue=""
                      />
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="email" className="form-label">Email</label>
                      <input  id="email" name="email"  type="email" className="form-control" autoComplete='off' placeholder='Email adddress' defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="profile" className="form-label">Profile</label>
                      <input  id="profile" name="profile" className="form-control" autoComplete='off' placeholder='Enter Your Profile' required defaultValue=""/>
                </div>

                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="age" className="form-label">Date of Birth</label>
                      <input type='date' id="age" name="age" className="form-control" autoComplete='off' defaultValue=""/>
                </div>
                <div className="col-lg-6">
  <label htmlFor="qual" className="form-label">Qualification</label>
  <Select
    id="qual"
    name="qual"
    options={qualificationOptions}
    placeholder="Select Qualification"
    isSearchable={true}
    // Find the option object that matches our state string
    value={qualificationOptions.find(obj => obj.value === filters.qual) || null}
    onChange={(selected) => handleSelectChange("qual", selected)}
    className={`react-select ${!filters.qual ? "is-invalid":""}`}
  />
</div>

<div className="col-lg-6">
  <label htmlFor="exp" className="form-label">Experience</label>
  <Select
    id="exp"
    name="exp"
    options={experienceOptions}
    placeholder="Enter Experience"
    isSearchable={true}
    // Find the option object that matches our state string
    value={experienceOptions.find(obj => obj.value === filters.exp) || null}
    onChange={(selected) => handleSelectChange("exp", selected)}
    className={`react-select ${!filters.exp ? "is-invalid":""}`}
  />
</div>
                <div className="col-lg-6">
                       <label htmlFor="pincode" className="form-label">Pincode</label>
                      <input  id="pincode" name="pincode" className="form-control" autoComplete='off' minLength={6} maxLength={6} placeholder='Enter Your Pincode' defaultValue=""/>
                </div>

                <div className="col-lg-6">
                       <label htmlFor="city" className="form-label">City/District</label>
                      <input  id="city" name="city" className="form-control" autoComplete='off' placeholder='Enter City' defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="state" className="form-label">State</label>
                      <input  id="state" name="state" className="form-control" autoComplete='off'  placeholder='Enter your State' defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-2" id='resumelabel'>
                     {/* Category Input */}
                     <p className="form-label">Upload Resume</p>
                      <input id="resume" accept="image/*,.pdf" onChange={handleFileChange} name="resume" className="form-control" autoComplete='off' type='file' defaultValue="" style={{display:'none'}}/>
                      <label htmlFor="resume"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <span style={{fontSize:'35px',marginTop:'-9px',display:'inline-block'}}>+</span>
                      </label>
                </div>
                <div className='col-lg-4' id='fileTxt'>
        {fileUrl && fileType?.startsWith('image/') && (
          <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%' ,height:'150px'}} />
        )}

        {fileUrl && fileType == 'application/pdf' && (
          <iframe src={fileUrl} title="PDF Preview" style={{width:'100%',height:'150px'}}></iframe>
        )}

        {fileUrl && !fileType.startsWith('image/') && fileType != 'application/pdf' && (
          <p>File preview not supported for this file type.</p>
        )}
      </div>
        
             <div className='col-12'  style={{padding:'0px',textAlign:'right'}}>
              <input type="hidden" name="hidden" id="hidden" />
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type='hidden' name='aidtype' id='aidtype' value={aidtype}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Submit</button>
            </div>
    </div>
      </form>

      <img className="order-1" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-88.svg"} style={{width:'100%',height:'100%'}}/> 

   </div>
   
 
</div>

</div>

<div className="offcanvas offcanvas-end" style={{width:'45%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="bulkmodal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">Candidate Registration in Bulk</h5>
        <button type="button" className="btn-close" id='modalclose2' data-bs-dismiss="offcanvas" aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   <form id="bulkform" onSubmit={BulkFormSubmit} encType="multipart/form-data">
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name2" className="form-label">Spoc Name</label>
                      <input  id="name2" name="name2" className="form-control" autoComplete='off'  placeholder='Spoc Name' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile2" className="form-label">Spoc Mobile No.</label>
                      <input  id="mobile2" name="mobile2" className="form-control" autoComplete='off' placeholder='Spoc Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
             
                <div className="col-lg-6">
                       <label htmlFor="location2" className="form-label">Spoc Location</label>
                      <input  id="location2" name="location2" className="form-control" autoComplete='off' placeholder='Spoc Location' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>

                <div className="col-lg-6" style={{display:'flex',width:'100%'}}>
                                    <button className="btn btn-sm btn-danger" onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=1`;}} type="button">Sample Bulk File Download</button>
                                    <button className="btn btn-sm btn-info" style={{marginLeft:'20px'}} onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=2`;}} type="button">CSV File Steps PDF</button>
                    </div>

                <div className='col-12'>
                  <p className="form-label">Scan File</p>
                      <input id="bulk" style={{display:'none'}}  accept=".csv" name="bulk" className="form-control" autoComplete='off' type='file' defaultValue=""  onChange={handleFileChange2}/>
                    <label htmlFor="bulk"  className='form-label' style={{float:'left',marginRight:'30px',width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <i className='ri-qr-scan-2-line' style={{fontSize:'25px'}}></i>
                      </label>
                       {/* File Info */}
        {fileInfo && (
          <div style={{marginTop:'10px',float:'left'}}>
            <div style={{ fontWeight: "500" }}>{fileInfo.name}</div>
            <small style={{ color: "#6c757d" }}>
              {(fileInfo.size / 1024).toFixed(2)} MB
            </small>
          </div>
        )}
                </div>
     
             <div className='col-12' style={{padding:'0px',textAlign:'right',position:'fixed',bottom:'20px',right:'20px'}}>
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type='hidden' name='aidtype' id='aidtype' value={aidtype}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Upload</button>
            </div>
    </div>
      </form>
</div>

</div>

<div className="main-content app-content">

 <div className="container-fluid">

  {/* Breadcrumb — only for lineup flows */}
  {(aidtype === '10' || aidtype === '301' || aidtype === '302') && (() => {
    const middleLabel = aidtype === '301' ? 'Open Campaign' : aidtype === '302' ? 'Paid Campaign' : 'Candidate Line Up';
    const reqId = stats.find(s => s.label === 'Requirement ID')?.count || '';
    return (
      <div className="mt-4 mb-3">
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'12px', flexWrap:'wrap', gap:'10px' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:'2px', background:'#f1f5f9', borderRadius:'10px', padding:'5px 10px', border:'1px solid #e2e8f0' }}>
            <button
              onClick={() => navigate(-2)}
              style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
              onMouseLeave={e => e.currentTarget.style.background='none'}
            >
              <FormatListBulleted sx={{ fontSize:'0.95rem', color:'#3b82f6' }} />
              Line Up
            </button>
            <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />
            <button
              onClick={() => navigate(-1)}
              style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
              onMouseLeave={e => e.currentTarget.style.background='none'}
            >
              <PeopleAltOutlined sx={{ fontSize:'0.95rem', color:'#10b981' }} />
              {middleLabel}
            </button>
            <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />
            <span style={{ display:'inline-flex', alignItems:'center', gap:'5px', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:600, color:'#1e293b', background:'#ffffff', border:'1px solid #cbd5e1' }}>
              <AssignmentOutlined sx={{ fontSize:'0.95rem', color:'#8b5cf6' }} />
              {reqId || 'Candidates'}
            </span>
          </div>
          <button
            className="btn btn-primary"
            onClick={() => navigate(-1)}
            style={{ display:'inline-flex', alignItems:'center', gap:'6px', fontWeight:500, padding:'8px 20px', fontSize:'0.9rem' }}
          >
            <ArrowBackIosNew sx={{ fontSize:'0.85rem' }} />
            Back
          </button>
        </div>
        <h4 className="fw-semibold mb-0" style={{ fontSize:'1.25rem', color:'#1e293b' }}>{middleLabel} — {reqId}</h4>
      </div>
    );
  })()}

    <div className="row">

  <div class="col-xl-12 mt-3">
      <div class="card custom-card">
          <div class="card-header" style={{display:'flex',justifyContent:'space-between'}}><div class="card-title">Campaign Details </div>
           {(metaData.typess.toUpperCase() === 'STAFF' && aidtype === '3') && (
    <button
      className="btn btn-primary"
      type="button"
      onClick={() => $("#showRecruiterModal").click()}
      style={{ marginRight: '20px' }}
      disabled={selectedRows.length === 0}
    >
      Select Recruiter
    </button>
  )}

  {(metaData.typess.toUpperCase() === 'STAFF' && (aidtype === '301' || aidtype === '302' || aidtype === '10')) && (
    <div className="d-flex align-items-center gap-2" style={{ marginRight: '20px' }}>
      <button
        className="btn text-white d-inline-flex align-items-center gap-2"
        type="button"
        style={{
          background: selectedRows.length === 0 ? '#94a3b8' : 'linear-gradient(135deg, #12337f, #1d4ed8)',
          border: 'none',
          borderRadius: '10px',
          padding: '10px 18px',
          boxShadow: selectedRows.length === 0 ? 'none' : '0 8px 18px rgba(29, 78, 216, 0.24)',
          fontWeight: 600,
        }}
        onClick={() => updateDetails(aid, aidtype)}
        disabled={selectedRows.length === 0}
      >
        <KeyboardArrowRight sx={{ fontSize: '1.15rem' }} />
        Line Up
      </button>
      <button
        className="btn d-inline-flex align-items-center gap-2"
        type="button"
        style={{
          background: latestLineupId ? '#ffffff' : '#f1f5f9',
          color: latestLineupId ? '#12337f' : '#94a3b8',
          border: latestLineupId ? '1px solid #12337f' : '1px solid #cbd5e1',
          borderRadius: '10px',
          padding: '10px 18px',
          fontWeight: 600,
        }}
        onClick={() => latestLineupId && navigate(`/admin/alllineup/${latestLineupId}/112`)}
        disabled={!latestLineupId}
      >
        <FormatListBulleted sx={{ fontSize: '1.05rem' }} />
        View Lineup List
      </button>
    </div>
  )}

  {(metaData.typess.toUpperCase() === 'STAFF' && aidtype === '202') && (
    <button
      className="btn btn-primary"
      type="button"
      onClick={SendForApproval}
      style={{ marginRight: '20px' }}
      disabled={selectedRows.length === 0 || isSubmittingRequest}
    >
      OPEN CAMPAIGN REQUEST
    </button>
  )}
          </div>
          <div class="card-body">
              <div class="row gy-md-0 gy-3" style={{gap:'15px 60px'}}>
   
   {stats.map((item, index) => (
   
   <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                      <div class="d-flex align-items-top">
                          <div>
                              <span class="d-block mb-1 text-muted">{item.label}</span>
                              <h6 class="fw-semibold mb-0">{item.count}</h6>
                          </div>
                      </div>
                  </div>
  
    ))}
   </div>
   
          </div>
      </div>
  </div>
  
  </div>

<div className="row">
   
<div className="col-xxl-12 col-xl-12 ">
   
<div className="card custom-card">
  
<div className="card-header justify-content-between" style={{paddingBottom:'10px',alignItems:'normal'}}>

{(aidtype === '3') ? (
 
   <nav className="nav nav-style-1 nav-pills gap-3" role="tablist">
    <button
      className={`nav-link ${activeTab === "recruiter" ? "active" : ""}`}
      onClick={() => setActiveTab("recruiter")}
    >
      Recruiter <span className="badge bg-danger ms-1 rounded-pill">{recruiterCandidates.length}</span>
    </button>

    <button
      className={`nav-link ${activeTab === "vendor" ? "active" : ""}`}
      onClick={() => setActiveTab("vendor")}
    >
      Vendor <span className="badge bg-danger ms-1 rounded-pill">{vendorCandidates.length}</span>
    </button>
  </nav>
) : (
 
 <div className="d-flex align-items-center gap-3 mb-0">
    {aidtype !== '2' && (
      <>
        {/* Both */}
        <label className="btn btn-primary text-white position-relative" style={{ minWidth: '120px' }}>
          <input
            type="checkbox"
            checked={!showVendor && !showRecruiter}
            onChange={() => {
              setShowVendor(false);
              setShowRecruiter(false);
            }}
            style={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'scale(1.1)',
              cursor: 'pointer'
            }}
          />
          <span>Both</span>
          <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
            {primaryCount}
          </span>
        </label>

        {/* Recruiter */}
        <label className="btn btn-info text-white position-relative" style={{ minWidth: '130px' }}>
          <input
            type="checkbox"
            checked={showRecruiter}
            onChange={() => setShowRecruiter(!showRecruiter)}
            style={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'scale(1.2)',
              cursor: 'pointer'
            }}
          />
          <span>Recruiter</span>
          <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
            {warningCount}
          </span>
        </label>

        {/* Vendor */}
        <label className="btn btn-secondary text-white position-relative" style={{ minWidth: '130px' }}>
          <input
            type="checkbox"
            checked={showVendor}
            onChange={() => setShowVendor(!showVendor)}
            style={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'scale(1.2)',
              cursor: 'pointer'
            }}
          />
          <span>Vendor</span>
          <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
            {secondaryCount}
          </span>
        </label>
      </>
    )}
  </div>
)}
    
     <div className="d-flex mt-sm-0 mt-2 align-items-center">
        <div className="input-group" style={{width:'auto'}}>
            <input type="text" className="form-control bg-light border-0" placeholder="Search Candidate" aria-describedby="search-contact-member" />
            <button className="btn btn-light" style={{zIndex:'0'}} type="button" id="search-contact-member"><i className="ri-search-line text-muted"></i></button>
        </div>
        {/* add candidates */}
        {(metaData.typess.toUpperCase() == 'ADMIN' || metaData.add===1) && (
        <> 
         {/* {(aidtype === '10' || aidtype === '202') && (
         <button
           className="btn btn-primary ms-2"
           type="button"
           title={hasMappedLineupCases ? "Open mapped IDP candidates" : "Check mapped IDP candidates"}
           data-bs-toggle="modal"
           data-bs-target="#mappedCasesModal"
           onClick={openMappedCasesModal}
         >
           IDP Candidates
         </button>
         )} */}
         <button className="btn btn-primary ms-2" data-bs-toggle="offcanvas" id="bulkupload" data-bs-target="#bulkmodal">Bulk Upload</button>
         {aidtype === '202' && (
         <button
           className="btn btn-warning ms-2"
           onClick={() => { setExternalView('pending'); setSelectedExternal([]); setShowExternalModal(true); fetchExternalCandidates(); }}
         >
           External Candidates
         </button>
         )}
         <button className="btn btn-icon btn-primary ms-2" data-bs-toggle="offcanvas" id="addStaffbtn" data-bs-target="#exampleModal" ><i className="ri-add-line" data-tooltip-content="Add Candidate" data-tooltip-id='global-tooltip'></i></button>
        </>
        )}

    </div>
  
</div>

<div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>


 <TableBody>
    {processedData.map((row, index) => {
      const isSelected = selectedRows.includes(row.id);
        return(
        <TableRow key={index} 
                onClick={() => handleRowSelect(row.id, !isSelected)}
                sx={{ 
                    cursor: 'pointer', // Optional: visually indicate row is clickable
                    backgroundColor: isSelected ? "#d0ebff" : 'inherit',
                    '&:hover': {
                        backgroundColor: isSelected ? "#a3d3ff" : '#f5f5f5', // Darker hover for selected, light hover for unselected
                    }
                }}
           
        >
            {columns.map((column) => {
                let cellContent;
                const cellWidth = column.size ? column.size : 150;
                 
                if (column.Cell) {
                    cellContent = column.Cell({ row: { original: row } });
                }
                // 2. Handle specific accessorKeys with custom logic (like 'rid')
                else {
                        const value = column.selector ? column.selector(row) : null;
                        cellContent = value;
                
              }
                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
        );
})}
    
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>
               
            </Table></TableContainer>
          
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>

</div>
        
</div></div>

</div></div>

</>
);
}
export default Register;
